import { render, staticRenderFns } from "./BannerGira.vue?vue&type=template&id=23db9c58&"
import script from "./BannerGira.vue?vue&type=script&lang=js&"
export * from "./BannerGira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports